<template>
  <form class="login-form" @submit.prevent="onSubmit">
    <dx-form :form-data="formData" :disabled="loading" :col-count="2">

      <dx-item :col-span="2" data-field='phone' editor-type='dxTextBox'
              :editor-options="{ stylingMode: 'filled', placeholder: '手机号', mode: 'text' }">
        <dx-required-rule message="手机号必填" />
        <dx-label :visible="false" />
      </dx-item>

      <dx-item v-show="loginMethod" :col-span="2" data-field="password" editor-type="dxTextBox"
               :editor-options="{ stylingMode: 'filled', placeholder: '密码', mode: 'password' }">
          <dx-required-rule message="密码不能为空" />
          <dx-label :visible="false" />
      </dx-item>

<!--      <dx-item :col-span="2">
        <template #default>
          <div class="login-link" style="float: right">
            <router-link to="/login-code">验证码登录</router-link>
          </div>
        </template>
      </dx-item>-->

        <!--登录按钮-->
      <dx-button-item :col-span="2">
        <dx-button-options width="100%" type="default" template="signInTemplate" :use-submit-behavior="true">
        </dx-button-options>
      </dx-button-item>
      <template #signInTemplate>
        <div style="display: flex;flex-direction: row;justify-content: center">
          <span class="dx-button-text">
            <dx-load-indicator v-if="loading" width="24px" height="24px" :visible="true" />
            <span v-if="!loading">登录</span>
          </span>
        </div>
      </template>

<!--      <dx-item>-->
<!--        <template #default>-->
<!--          <div class="login-link">-->
<!--            还没有账号? <router-link to="/create-account">注册</router-link>-->
<!--          </div>-->
<!--        </template>-->
<!--      </dx-item>-->
    </dx-form>
  </form>
</template>

<script>

import DxLoadIndicator from "devextreme-vue/load-indicator";
import DxForm, {
  DxItem,
  DxEmailRule,
  DxRequiredRule,
  DxLabel,
  DxButtonItem,
  DxButtonOptions
} from "devextreme-vue/form";
import notify from 'devextreme/ui/notify';

import auth from "../auth";

export default {

  data() {
    return {
      formData: {},
      loading: false,
      codeMessage:"获取验证码",
      loginMethod: true,
    };
  },
  methods: {
    onSubmit: async function() {
        let that = this

        this.$http.accountLogin(this.formData).then( async function (res) {
        if(res.status != "success"){
          that.$message({type: 'error', message: res.msg, center: true});
          return ;
        }
          //  数据持久化

          that.loading = true;
        const result = await auth.logIn(res.data.user, "");
        if (!result.isOk) {
            that.loading = false;
          that.$message({type: 'error', message: result.message, center: true});
        } else {
            localStorage.setItem("token",res.data.token)
          that.$websocket.initWebSocket(res.data.token);
          that.$message({type: 'success', message: res.msg, center: true});
            await that.$router.push("/home");
        }
      })

    },
  },
  components: {
    DxLoadIndicator,
    DxForm,
      // eslint-disable-next-line vue/no-unused-components
    DxEmailRule,
    DxRequiredRule,
    DxItem,
    DxLabel,
    DxButtonItem,
    DxButtonOptions
  }
};
</script>

<style lang="scss">
@import "../themes/generated/variables.base.scss";

.login-form {
    margin-top: 20px;
  .link {
    text-align: center;
    font-size: 16px;
    font-style: normal;

    a {
      text-decoration: none;
    }
  }
.login-link{
    font-size: 14px;
}
  .form-text {
    margin: 10px 0;
    color: rgba($base-text-color, alpha($base-text-color) * 0.7);
  }
}
</style>
